export const COLUMN_HEADERS = {
  "Enrollment Start": "Enrollment Start",
  "Number of Activated Sites": "# Sites",
  "Screen Rate": "Average Screen Rate",
  "Screen Rate Go Forward": "Go-Forward Screen Rate",
  "Enrollment Rate": "Average Enrollment Rate",
  "Enrollment Rate Go Forward": "Go-Forward Enrollment Rate",
  "Number of Patients Screened": "# Participants Screened",
  "Number of Patients Enrolled": "# Participants Enrolled",
  "Number of Patients Completing Treatment": "# Participants Completed",
  "Enrollment Duration": "Enrollment Duration (months)",
  "Screen Fail Rate": "Screen Fail Rate",
  "Drop Out Rate": "Drop Out Rate",
  "Site Months": "Screening Site Months",
};
